// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/wake-roll-hazard.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/wake-roll-hazard/wake-roll-hazard.js';

mount([g0]);
